// extracted by mini-css-extract-plugin
export default {"typeImg":"AccountType_typeImg__fhpBl"};